/** ===========
 * 全局自定义指令
 * ============
 */
// import infiniteScroll from "./directives/infiniteScroll";
import follower from '@/directives/follower';
import dragWhole from '@/directives/drag';
import Clickoutside from 'element-ui/src/utils/clickoutside';
export default {
  /**
   * 滚动加载
   * 用于列表项的包裹元素上，接收一个对象作为参数
   * @loadFn {function} 必选。为数据加载的方法，当**指令绑定的元素底边出现在视窗内**便会触发此方法
   * @wrapper {string} 可选。指定监听滚动事件的目标对象，需将其`ref`值传入。默认为空，则会监听window的滚动事件
   */
  // infiniteScroll: infiniteScroll,
  /**
   * 用于图片懒加载。用于<img>标签，将图片地址传入即可。
   */
  lazyload: {
    bind() {
      // console.log(`bind:`);
    },
    inserted: (el, binding) => {
      if (window.IntersectionObserver) {
        binding.def.observer = new IntersectionObserver((changes) => {
          for (const change of changes) {
            let intersectionRatio = change.intersectionRatio;
            // 出现在视野中且未加载过
            if (intersectionRatio && !el.src) {
              // console.log(`出现在视野中且未加载过:`);
              el.src = binding.value;
            } else {
              // console.log('我隐身了:');
              return;
            }
          }
        });
        binding.def.observer.observe(el);
      } else {
        window.addEventListener('scroll', binding.def.scrollHandler.bind(null, el, binding));
      }
    },
    unbind: (el, binding) => {
      window.IntersectionObserver ? binding.def.observer.unobserve(el) : window.removeEventListener('scroll', binding.def.scrollHandler);
    },
    observer: {},
    scrollHandler(el, binding) {
      // 通过指令的el参数拿到img，判断其是否在视口内
      if (binding.def.isInViewport(el, binding) && !el.src) {
        el.src = binding.value;
      }
    },
    // 判断图片是否在视口区域内
    // 可用于lazyload, infinite scroll等常见功能
    isInViewport(el) {
      // 获取视口
      function getViewport() {
        if (document.compatMode == 'backCompat') {
          return {
            width: document.body.clientWidth || window.innerWidth,
            height: document.body.clientHeight || window.innerHeight
          };
        } else {
          return {
            width: document.documentElement.clientWidth || window.innerWidth,
            height: document.documentElement.clientHeight || window.innerHeight
          };
        }
      }
      let rect = el.getBoundingClientRect();
      let viewport = getViewport();

      return rect.bottom > 0 && rect.top < viewport.height && rect.left < viewport.width && rect.right > 0;
    }
  },
  /**@description
   * 图片加载出来前会采用随机色填充;
   * 使用指令时把图片url作为属性值传入即可:
   * v-before-img-load="imgUrl"
   */
  beforeImgLoad: {
    inserted: (el, binding) => {
      let color = Math.floor(100000 + Math.random() * 900000); //生成随机6位数
      el.style.backgroundColor = `#${color}`; //设置随机颜色

      let img = new Image();
      img.src = binding.value;
      img.onload = function() {
        el.style.background = `url(${binding.value}) center/cover no-repeat`;
      };
    }
  },
  /**
   * 自动获取焦点
   */
  autoFocus: {
    inserted: (el) => {
      el.focus();
    }
  },
  timeouter: {
    inserted: (el, binding) => {
      var startTime = new Date(binding.value[0]).getTime();
      var endTime = new Date(binding.value[1]).getTime();
      var nowTime = new Date().getTime();
      if (nowTime < startTime || nowTime > endTime) {
        el.style.display = 'none';
      }
    }
  },
  /**
   * 在指令作用的元素范围内，生成一个鼠标跟随的元素。
   * 可自定义元素样式及元素内容。
   * 默认: v-follower
   * 自定义: v-follower="{style:{}, txt: ''}"
   */
  follower: follower,
  /**
   * 处理标节点之外的点击事件
   * v-clickoutside="outseideClickHandler()"
   */
  Clickoutside: Clickoutside,
  /*
   * 拖拽元素
   * 组件中有dragDown, dragUp, dragMove 事件
   * 根据action判断拖动元素
   * v-dragWhole
   */
  dragWhole: dragWhole
};
